"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDivider = exports.StyledTitle = exports.StyledOptionsContainer = exports.StyledSpacingContainer = void 0;
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const { rem } = ui_common_components_1.utils;
exports.StyledSpacingContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  cursor: pointer;

  ${({ theme }) => (0, styled_components_1.css) `
    padding: ${rem(theme.Spacing.Size.Small)} ${rem(theme.Spacing.Size.XSmall)};
    gap: ${rem(theme.Spacing.Size.Small)};
  `}
`;
exports.StyledOptionsContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
`;
exports.StyledTitle = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;
exports.StyledDivider = styled_components_1.default.hr `
  width: 100%;
  border: none;

  ${({ theme }) => (0, styled_components_1.css) `
    border-top: ${rem(theme.Border.Size.Small)} solid
      ${theme.Color.Neutrals.Border};
  `}
`;
//# sourceMappingURL=Spacing.styles.js.map